var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMessages({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_7496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0C9.55219 0 6.24558 1.36964 3.80761 3.80761C1.36964 6.24558 0 9.55219 0 13C0 16.4478 1.36964 19.7544 3.80761 22.1924C6.24558 24.6304 9.55219 26 13 26C16.4478 26 19.7544 24.6304 22.1924 22.1924C24.6304 19.7544 26 16.4478 26 13C26 9.55219 24.6304 6.24558 22.1924 3.80761C19.7544 1.36964 16.4478 0 13 0ZM5.32025 7.67975H17.7309C18.3548 7.68884 18.9502 7.94256 19.3889 8.3863C19.8275 8.83003 20.0744 9.42829 20.0763 10.0523V16.4038C20.0666 17.0264 19.815 17.6207 19.3748 18.0611C18.9347 18.5014 18.3405 18.7533 17.7179 18.7633H8.71C7.43817 18.7633 6.5 17.6908 6.5 16.4038V11.3783L4.87825 8.56375C4.54242 8.10875 4.82408 7.67975 5.32025 7.67975ZM9.01983 10.0523C8.64392 10.0523 8.28317 10.2797 8.28317 10.6416C8.28317 11.0034 8.64392 11.2309 9.01983 11.2309H17.5836C17.9584 11.2309 18.3202 11.0034 18.3202 10.6416C18.3202 10.2797 17.9584 10.0512 17.5836 10.0512L9.01983 10.0523ZM9.01983 12.4107C8.64392 12.4107 8.28317 12.6382 8.28317 13C8.28317 13.3618 8.64392 13.5893 9.01983 13.5893H17.5836C17.9584 13.5893 18.3202 13.3618 18.3202 13C18.3202 12.6382 17.9584 12.4107 17.5836 12.4107H9.01983ZM9.00575 14.7832C8.63092 14.7832 8.26908 15.0107 8.26908 15.3725C8.26908 15.7343 8.63092 15.9618 9.00575 15.9618H15.2111C15.587 15.9618 15.9478 15.7343 15.9478 15.3725C15.9478 15.0107 15.587 14.7821 15.2111 14.7821L9.00575 14.7832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_7496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMessages);
export default __webpack_public_path__ + "static/media/GoogleMessages.40e787341a6acc66e056b35aa0c1849b.svg";
export { ForwardRef as ReactComponent };